<template>
  <div id="PaymentList">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" ref="searchInput" placeholder="请输入付款人、付款单位、订单编号" />
    </eb-header>
    <eb-date-search :listRequestData="listRequestData" ref="radioSelect">
      <el-button name="slot" class="eb-button-group-btn eb-button-orange button" @click="searchDateClick">搜索</el-button>
      <template v-if="listRequestData.roleId != 1">
        <el-button name="slot" class="eb-button-group-btn eb-button-orange button" @click="applyInvoice">申请发票</el-button>
      </template>
    </eb-date-search>
    <div class="table table-box eb-table">
      <el-table :data.sync="pageData" ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop='transationTime' label="付款时间" min-width="150" sortable='custom'>
          <template slot-scope="scope">
            {{transationTime(scope.row.transationTime)}}
          </template>
        </el-table-column>
        <template v-if="listRequestData.roleId == 1">
          <el-table-column prop='trueName' label="付款人" min-width="100" sortable='custom'>
            <template slot-scope="scope">
              <a @click="showUserInfo(scope.row.orderUserId)" href="javascript:void(0)" class="a-font-red">{{scope.row.trueName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop='departName' label="付款单位" min-width="180" sortable='custom'></el-table-column>
        </template>
        <el-table-column prop='orderType' label="付款类别" width="110" sortable='custom'>
          <template slot-scope="scope">
            {{orderType(scope.row.orderType)}}
          </template>
        </el-table-column>
        <el-table-column prop='sysOrderNumber' label="订单编号" min-width="120" sortable='custom'>
          <template slot-scope="scope">
            <template v-if="listRequestData.roleId != 1">
              <a @click="showOrderDetail(scope.row.sysOrderNumber,scope.row.orderType,scope.row.orderUserId)" href="javascript:void(0)" class="a-font-red">{{scope.row.sysOrderNumber}}</a>
            </template>
            <template v-else>
              {{scope.row.sysOrderNumber}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop='transationAmount' label="付款金额" width="110" sortable='custom'></el-table-column>
        <el-table-column prop='couponAmount' label="优惠金额" width="110" sortable='custom'></el-table-column>
        <el-table-column prop='applyStatus' label="发票状态" width="110" sortable='custom'>
          <template slot-scope="scope">
            {{applyStatus(scope.row.applyStatus)}}
          </template>
        </el-table-column>
      </el-table>
      <eb-pagination :current-page.sync="listRequestData.start" v-if="recordsTotal" @current-change="paginationData" :total="recordsTotal" />
    </div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import ebDateSearch from '@/components/common/eb-date-search';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { findPaymentList } from '@/services/payment-service';
import { findProjectInfoByOrderNum } from '@/services/notarization/notarization-service';
import eventBus from '@/plugins/event-bus';
import { clone } from 'lodash';
export default {
  name: 'PaymentList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    ebDateSearch,
    ebPagination
  },
  data() {
    return {
      loading: true,
      pageData: [],
      recordsTotal: null,
      listRequestData: {
        start: 1,
        length: 10,
        orderProp: 'transationTime',
        orderType: 'desc',
        startTime: '',
        endTime: '',
        orderUserId: this.$store.state.user.userInfo.userid,
        roleId: this.$store.state.user.userInfo.roleid,
        content: '',
        selected: '0'
      },
      roleId: this.$store.state.user.userInfo.roleid,
      orgId: this.$store.state.user.userInfo.orgId,
      multipleSelection: [], // 当前页选中的数据  multipleSelection
      multipleSelectionAll: [], // 所有选中的数据包含跨页数据
      idKey: 'paymentId' // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
    };
  },
  created() {
    this.initPayRecordList();
  },
  methods: {
    async initPayRecordList() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await findPaymentList(this.listRequestData);
        if (data.returnCode === '01') {
          this.pageData = data.data;
          this.recordsTotal = data.recordsTotal;
          setTimeout(() => {
            this.setSelectRow();
          }, 50);
        } else {
          this.$message.error('查询支付记录失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
      this.$root.layout.isLoading = false;
    },
    orderType(type) {
      return this.$options.filters['orderType'](type);
    },
    applyStatus(status) {
      return this.$options.filters['applyStatus'](status);
    },
    transationTime(time) {
      return this.$options.filters['dateTimeStandardFormat'](time);
    },
    sortChange(columnData) {
      this.changePageCoreRecordData();
      this.listRequestData.orderProp = columnData.prop;
      switch (columnData.order) {
        case 'descending':
          this.listRequestData.orderType = 'desc';
          break;
        case 'ascending':
          this.listRequestData.orderType = 'asc';
          break;
      }
      this.initPayRecordList();
    },
    // 点击搜索
    searchData: function(searchKey) {
      if (searchKey === '') {
        this.$refs.radioSelect.selected = '0';
        this.$refs.radioSelect.selectedCurrent('0');
      }
      this.listRequestData.content = searchKey;
      this.initPayRecordList();
    },
    // 分页
    paginationData(pageNum) {
      this.changePageCoreRecordData();
      this.listRequestData.start = pageNum;
      this.initPayRecordList();
    },
    searchDateClick() {
      this.listRequestData.content = this.$refs.searchInput.text;
      this.initPayRecordList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // 实时记录选中的数据
      setTimeout(() => {
        this.changePageCoreRecordData();
      }, 50);
    },
    // 设置选中的方法
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let selectAllIds = [];
      this.multipleSelectionAll.forEach(row => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.multipleTable.clearSelection();
      for (var i = 0; i < this.pageData.length; i++) {
        if (selectAllIds.indexOf(this.pageData[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="multipleTable"
          this.$refs.multipleTable.toggleRowSelection(this.pageData[i], true);
        }
      }
    },
    // 记忆选择核心方法
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      let selectAllIds = [];
      this.multipleSelectionAll.forEach(row => {
        selectAllIds.push(row[idKey]);
      });
      let selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach(row => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      let noSelectIds = [];
      // 得到当前页没有选中的id
      this.pageData.forEach(row => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach(id => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] === id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },
    applyInvoice() {
      if (this.multipleSelectionAll.length === 0) {
        this.$message.error('请选择要开发票的数据');
        return false;
      }
      let applyData = clone(this.multipleSelectionAll);
      let total = 0;
      let orderIds = [];
      let alreadyApply = [];

      applyData.forEach(item => {
        if (item.applyStatus !== '0') {
          alreadyApply.push(item.sysOrderNumber);
        }
        orderIds.push("'" + item.sysOrderNumber + "'");
        total += item.transationAmount;
      });
      if (alreadyApply.length > 0) {
        this.$message.error('您所选数据中有已申请或者已开票的数据，请重新选择');
        return;
      }
      sessionStorage.setItem('orderList', JSON.stringify(applyData));
      sessionStorage.setItem('total', parseFloat(total).toFixed(2));
      sessionStorage.setItem('orderIds', JSON.stringify(orderIds));
      this.$router.push({
        name: 'ApplyInvoice'
      });
    },
    showUserInfo(userId) {
      eventBus.$emit('userInfoDialog', userId);
    },
    async showOrderDetail(sysOrderNumber, orderType, userId) {
      let roleId = this.roleId + '';
      if (orderType === 'SJTS1804') {
        if (roleId === '6' || roleId === '7' || roleId === '8' || roleId === '9') {
          this.$router.push('/busi/opptypush/list');
        } else {
          this.$message.error('此角色没有商机订阅查询权限,请切换角色查看!');
        }
      } else if (orderType === 'SMRZ1804') {
        this.$router.push('/org/detail/' + this.orgId);
      } else if (orderType === 'HGJZ1808') {
        try {
          let { data } = await findProjectInfoByOrderNum(sysOrderNumber);
          if (data.returnCode === '01') {
            let projectId = data.projectId;
            if (data.projectMethod === '1') {
              if (roleId === '6' || roleId === '7') {
                this.$router.push('/projpro/quotation/summary/' + projectId);
              } else if (roleId === '8' || roleId === '9') {
                sessionStorage.setItem('searchContent', data.projectCode);
                this.$router.push('/projpro/quoted/list');
              } else {
                this.$message.error('此角色没有项目查询权限,请切换角色查看!');
              }
            } else if (data.projectMethod === '2') {
              if (roleId === '6' || roleId === '7') {
                this.$router.push('/projbid/quotation/summary/' + projectId);
              } else if (roleId === '8' || roleId === '9') {
                sessionStorage.setItem('searchContent', data.projectCode);
                this.$router.push('/projbid/quoted/list');
              } else {
                this.$message.error('此角色没有项目查询权限,请切换角色查看!');
              }
            }
          } else {
            this.$message.error('查询项目信息失败！');
          }
        } catch (error) {
          this.$message.error('请检查服务器连接!');
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
#PaymentList {
  .table {
    padding: 10px 10px;
    max-width: 100%;
    margin-bottom: 20px;
    .a-font-red {
      color: #fb5b3b;
    }
  }
  .button {
    height: 22px;
    width: 82px;
  }
}
</style>
